export default __webpack_public_path__ + "static/media/icon-browser.6730ed1b.svg";